import { intl } from '@fullstory/intl';
import { PageDefinition } from '@fullstory/proto/fs/api/pages';
import { PatternRuleForm } from './types';
export const END_GROUP_ERROR = intl.formatMessage({
  defaultMessage: 'Expected "]" at end of group',
  id: 't635cJ',
});
export const FULL_POSITION_ERROR = intl.formatMessage({
  defaultMessage: 'Matching groups must span the full position',
  id: 'RuLLnn',
});
export const INVALID_ESCAPE_ERROR = intl.formatMessage({
  defaultMessage: '"\\" is not a valid character.  Escaping is not supported.',
  id: 'gjDFFB',
});
export const LEFT_BRACKET_ERROR = intl.formatMessage({
  defaultMessage:
    '"[" is not supported as a url character.  "[" may only be used as part of a group',
  id: 'BhDlEW',
});
export const RIGHT_BRACKET_ERROR = intl.formatMessage({
  defaultMessage:
    '"]" is not supported as a url character.  "]" may only be used as part of a group',
  id: 'O+KRN7',
});
export const WILDCARD_ERROR = intl.formatMessage({
  defaultMessage:
    'Partial wildcards are not supported. "*" can\'t be combined with other characters.',
  id: 'n3zUdq',
});
export const UNESCAPED_COMMA = intl.formatMessage({
  defaultMessage:
    '"," is not supported as a url character.  "," may only be used as part of a group',
  id: 'Q0vmA5',
});
export const EMPTY_GROUP_ERROR = intl.formatMessage({
  defaultMessage: 'Empty group',
  id: 'kt6EnJ',
});
export const QUERY_KEY_EMPTY = intl.formatMessage({
  defaultMessage: 'Query key cannot be empty.',
  id: '4SdCXv',
});
export const QUERY_NO_DOUBLE_WILDCARD = intl.formatMessage({
  defaultMessage: 'Double wildcard "**" is not supported for query value.',
  id: 'uiwu10',
});

export const EMPTY_PAGE_DEF: PageDefinition = {
  id: 0,
  friendlyId: '',
  name: '',
  description: '',
  archived: false,
  labels: [],
  patterns: [],
  createdBy: '',
  createdAt: null,
  updatedBy: '',
  updatedAt: null,
  isUserDefined: true,
  expiration: null,
  metadata: null,
  suggestion: null,
};

export const PAGE_SAVE_CONFLICT = 'PAGE_SAVE_CONFLICT';
export const PAGE_SAVE_SUCCESS = 'PAGE_SAVE_SUCCESS';
export const PAGE_SAVE_FAILURE = 'PAGE_SAVE_FAILURE';
export const PAGE_ARCHIVE_SUCCESS = 'PAGE_ARCHIVE_SUCCESS';
export const PAGE_ARCHIVE_FAILURE = 'PAGE_ARCHIVE_FAILURE';
export const PAGE_UNARCHIVE_SUCCESS = 'PAGE_UNARCHIVE_SUCCESS';
export const PAGE_UNARCHIVE_FAILURE = 'PAGE_UNARCHIVE_FAILURE';
export const CLOSED = 'CLOSED';

export const restrictedTooltip = intl.formatMessage({
  defaultMessage: 'Your account does not have permission to configure Pages.',
  id: 'Qbsy0/',
});
export const Mode = {
  edit: 'Edit',
  create: 'Create',
};

export const NO_PAGE_DATA_MESSAGE = intl.formatMessage({
  defaultMessage: 'There is no data for this page in this time period.',
  id: 'JxeFJM',
});
export const ADJUSTED_TIME_RANGE_MESSAGE = intl.formatMessage({
  defaultMessage: 'The time period has been adjusted to start when this page was created.',
  id: 'q5sToY',
});
export const INDEX_ADJUSTED_TIME_RANGE_MESSAGE = intl.formatMessage({
  defaultMessage:
    'The time period has been adjusted to the earliest date users viewed this page in your time range.',
  id: 'UyX4VW',
});

export const RejectionSuggestionOptions = {
  TOO_BROAD: 'too_broad',
  TOO_GRANULAR: 'too_granular',
  MISLEADING: 'misleading',
  DUPLICATIVE: 'duplicative',
  OTHER: 'other',
};

export const EMPTY_PATTERN: PatternRuleForm = {
  type: 'pattern',
  domains: { value: '' },
  path: { value: '' },
  fragment: { value: '' },
  query: { value: [] },
};
